module.exports = __webpack_public_path__ + "static/media/Stellar Ace Single Headboard - 120 cm_Black.439811fe.png";